// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button, input, select, textarea, .file-select-input {
  color: var(--text-color);
  font-family: var(--font-family);
  font-size: var(--font-size-l);
  box-sizing: border-box;
}

button, input, select, .file-select-input {
  height: var(--input-element-height);
  border-radius: calc(var(--input-element-height) / 2);
  padding: 0 var(--font-size-l);
}

input, select, textarea, .file-select-input {
  background-color: var(--input-background-color);
}

button,
.file-select-container {
  border: none;
  gap: var(--input-element-gap);
  min-width: var(--text-button-min-width);
  background-color: transparent;

  &:hover {
    cursor: pointer;
    box-shadow: 0px 0px 10px -2px var(--border-color);
  }

  &:active {
    box-shadow: 0px 0px 10px -2px var(--border-color), 0px 0px 20px -2px var(--border-color) inset;
  }
}

.shrinking-button {
  min-width: 0;
}

button,
.icon-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
}

button:disabled {
  opacity: 0.5;
  cursor: not-allowed !important;
  
  &:hover {
    box-shadow: none;
  }
}

button:focus-visible {
  outline: none;
}

input, select, textarea, .file-select-input {
  border: 1px solid var(--border-color);
  pointer-events: auto;
}

input:focus,
select:focus,
textarea:focus,
.file-select-input:focus,
.color-input-container:has(:focus-within) {
  outline: none;
  box-shadow: 0px 0px 12px -1px var(--border-color);
}

.input-warn-state {
  border: 1px solid var(--warn-color);
  box-shadow: 0px 0px 7px -1px var(--warn-color);
}

.input-warn-state:focus {
  box-shadow: 0px 0px 12px -1px var(--warn-color);
}

input:disabled {
  border-color: var(--light-grey);
  color: var(--medium-grey);
  cursor: not-allowed !important;
}

.icon-button,
.icon-button-numbered,
.icon-button-small,
.icon-button-large,
.icon-button-large-numbered {
  padding: 0;
  min-width: 0;
  color: var(--text-color);
}

.icon-button-small {
  width: var(--input-element-height-small);
  min-width: var(--input-element-height-small);
  height: var(--input-element-height-small);
  border-radius: calc(var(--input-element-height-small) / 2);
  font-size: var(--font-size-m);

  &.square-button {
    border-radius: calc(var(--input-element-height-small) / 4);
  }
}

.icon-button,
.icon-button-numbered {
  width: var(--input-element-height);
  min-width: var(--input-element-height);
  height: var(--input-element-height);
  border-radius: calc(var(--input-element-height) / 2);

  &.square-button {
    border-radius: calc(var(--input-element-height) / 4);
  }
}

.icon-button-numbered {
  font-size: var(--font-size-m);
  display: flex;
  flex-direction: column;

  > span {
    font-size: var(--font-size-s);
  }
}

.icon-button-large,
.icon-button-large-numbered {
  width: var(--input-element-height-large);
  min-width: var(--input-element-height-large);
  height: var(--input-element-height-large);
  border-radius: var(--input-element-height-large);

  &.square-button {
    border-radius: calc(var(--input-element-height-large) / 4);
  }
}

.icon-button-large {
  font-size: var(--font-size-xl);
}

.icon-button-large-numbered {
  font-size: var(--font-size-l);
  display: flex;
  flex-direction: column;

  > span {
    font-size: var(--font-size-m);
  }
}

.highlight-button {
  background-color: var(--input-highlight-background-color);
  color: var(--text-contrast-color);
  border: 1px solid var(--border-color);

  &:hover {
    box-shadow: 0px 0px 12px -1px var(--border-color);
  }
}

.input-invalid {
  border: 1px solid var(--warn-color);
}

input[type="checkbox"] {
  width: var(--font-size-l);
  box-shadow: none;
  cursor: pointer;
}

.labelled-checkbox-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--input-element-gap);
  font-size: var(--font-size-l);
}

input:checked {
  accent-color: var(--input-accent-color);
}

input[type="range"] {
  width: 100%;
  cursor: pointer;
  padding: 0;
  box-shadow: none;
  accent-color: var(--input-accent-color);
}

a {
  color: var(--input-accent-color);
  font-weight: bold;
  cursor: pointer;
}

input[type="number"] {
  min-width: 0;
  max-width: 200px;
  width: 100%;
}

.small-input {
  max-width: 100px !important;
  height: var(--small-input-height);
  border-radius: var(--small-input-border-radius);
  padding: 0 0 0 calc(var(--font-size-l) / 3);
  font-size: var(--font-size-m);
}

textarea {
  border-radius: var(--dialog-border-radius);
  padding: var(--input-element-gap);
}

textarea::-webkit-resizer {
  border-width: 100px; /* Make it really large, so we always see the border as a triangle */
  border-style: solid;
  border-color: transparent var(--border-color) var(--border-color) transparent;
  border-bottom-right-radius: calc(var(--dialog-border-radius) - 1px);
}
`, "",{"version":3,"sources":["webpack://./src/ui/style/elements/input-elements.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,oDAAoD;EACpD,6BAA6B;AAC/B;;AAEA;EACE,+CAA+C;AACjD;;AAEA;;EAEE,YAAY;EACZ,6BAA6B;EAC7B,uCAAuC;EACvC,6BAA6B;;EAE7B;IACE,eAAe;IACf,iDAAiD;EACnD;;EAEA;IACE,8FAA8F;EAChG;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,8BAA8B;;EAE9B;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;;;;;EAKE,aAAa;EACb,iDAAiD;AACnD;;AAEA;EACE,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;;;;;EAKE,UAAU;EACV,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,wCAAwC;EACxC,4CAA4C;EAC5C,yCAAyC;EACzC,0DAA0D;EAC1D,6BAA6B;;EAE7B;IACE,0DAA0D;EAC5D;AACF;;AAEA;;EAEE,kCAAkC;EAClC,sCAAsC;EACtC,mCAAmC;EACnC,oDAAoD;;EAEpD;IACE,oDAAoD;EACtD;AACF;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;;EAEtB;IACE,6BAA6B;EAC/B;AACF;;AAEA;;EAEE,wCAAwC;EACxC,4CAA4C;EAC5C,yCAAyC;EACzC,gDAAgD;;EAEhD;IACE,0DAA0D;EAC5D;AACF;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;;EAEtB;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,yDAAyD;EACzD,iCAAiC;EACjC,qCAAqC;;EAErC;IACE,iDAAiD;EACnD;AACF;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,UAAU;EACV,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,+CAA+C;EAC/C,2CAA2C;EAC3C,6BAA6B;AAC/B;;AAEA;EACE,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;EACE,mBAAmB,EAAE,oEAAoE;EACzF,mBAAmB;EACnB,6EAA6E;EAC7E,mEAAmE;AACrE","sourcesContent":["button, input, select, textarea, .file-select-input {\n  color: var(--text-color);\n  font-family: var(--font-family);\n  font-size: var(--font-size-l);\n  box-sizing: border-box;\n}\n\nbutton, input, select, .file-select-input {\n  height: var(--input-element-height);\n  border-radius: calc(var(--input-element-height) / 2);\n  padding: 0 var(--font-size-l);\n}\n\ninput, select, textarea, .file-select-input {\n  background-color: var(--input-background-color);\n}\n\nbutton,\n.file-select-container {\n  border: none;\n  gap: var(--input-element-gap);\n  min-width: var(--text-button-min-width);\n  background-color: transparent;\n\n  &:hover {\n    cursor: pointer;\n    box-shadow: 0px 0px 10px -2px var(--border-color);\n  }\n\n  &:active {\n    box-shadow: 0px 0px 10px -2px var(--border-color), 0px 0px 20px -2px var(--border-color) inset;\n  }\n}\n\n.shrinking-button {\n  min-width: 0;\n}\n\nbutton,\n.icon-button {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  pointer-events: auto;\n}\n\nbutton:disabled {\n  opacity: 0.5;\n  cursor: not-allowed !important;\n  \n  &:hover {\n    box-shadow: none;\n  }\n}\n\nbutton:focus-visible {\n  outline: none;\n}\n\ninput, select, textarea, .file-select-input {\n  border: 1px solid var(--border-color);\n  pointer-events: auto;\n}\n\ninput:focus,\nselect:focus,\ntextarea:focus,\n.file-select-input:focus,\n.color-input-container:has(:focus-within) {\n  outline: none;\n  box-shadow: 0px 0px 12px -1px var(--border-color);\n}\n\n.input-warn-state {\n  border: 1px solid var(--warn-color);\n  box-shadow: 0px 0px 7px -1px var(--warn-color);\n}\n\n.input-warn-state:focus {\n  box-shadow: 0px 0px 12px -1px var(--warn-color);\n}\n\ninput:disabled {\n  border-color: var(--light-grey);\n  color: var(--medium-grey);\n  cursor: not-allowed !important;\n}\n\n.icon-button,\n.icon-button-numbered,\n.icon-button-small,\n.icon-button-large,\n.icon-button-large-numbered {\n  padding: 0;\n  min-width: 0;\n  color: var(--text-color);\n}\n\n.icon-button-small {\n  width: var(--input-element-height-small);\n  min-width: var(--input-element-height-small);\n  height: var(--input-element-height-small);\n  border-radius: calc(var(--input-element-height-small) / 2);\n  font-size: var(--font-size-m);\n\n  &.square-button {\n    border-radius: calc(var(--input-element-height-small) / 4);\n  }\n}\n\n.icon-button,\n.icon-button-numbered {\n  width: var(--input-element-height);\n  min-width: var(--input-element-height);\n  height: var(--input-element-height);\n  border-radius: calc(var(--input-element-height) / 2);\n\n  &.square-button {\n    border-radius: calc(var(--input-element-height) / 4);\n  }\n}\n\n.icon-button-numbered {\n  font-size: var(--font-size-m);\n  display: flex;\n  flex-direction: column;\n\n  > span {\n    font-size: var(--font-size-s);\n  }\n}\n\n.icon-button-large,\n.icon-button-large-numbered {\n  width: var(--input-element-height-large);\n  min-width: var(--input-element-height-large);\n  height: var(--input-element-height-large);\n  border-radius: var(--input-element-height-large);\n\n  &.square-button {\n    border-radius: calc(var(--input-element-height-large) / 4);\n  }\n}\n\n.icon-button-large {\n  font-size: var(--font-size-xl);\n}\n\n.icon-button-large-numbered {\n  font-size: var(--font-size-l);\n  display: flex;\n  flex-direction: column;\n\n  > span {\n    font-size: var(--font-size-m);\n  }\n}\n\n.highlight-button {\n  background-color: var(--input-highlight-background-color);\n  color: var(--text-contrast-color);\n  border: 1px solid var(--border-color);\n\n  &:hover {\n    box-shadow: 0px 0px 12px -1px var(--border-color);\n  }\n}\n\n.input-invalid {\n  border: 1px solid var(--warn-color);\n}\n\ninput[type=\"checkbox\"] {\n  width: var(--font-size-l);\n  box-shadow: none;\n  cursor: pointer;\n}\n\n.labelled-checkbox-container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: var(--input-element-gap);\n  font-size: var(--font-size-l);\n}\n\ninput:checked {\n  accent-color: var(--input-accent-color);\n}\n\ninput[type=\"range\"] {\n  width: 100%;\n  cursor: pointer;\n  padding: 0;\n  box-shadow: none;\n  accent-color: var(--input-accent-color);\n}\n\na {\n  color: var(--input-accent-color);\n  font-weight: bold;\n  cursor: pointer;\n}\n\ninput[type=\"number\"] {\n  min-width: 0;\n  max-width: 200px;\n  width: 100%;\n}\n\n.small-input {\n  max-width: 100px !important;\n  height: var(--small-input-height);\n  border-radius: var(--small-input-border-radius);\n  padding: 0 0 0 calc(var(--font-size-l) / 3);\n  font-size: var(--font-size-m);\n}\n\ntextarea {\n  border-radius: var(--dialog-border-radius);\n  padding: var(--input-element-gap);\n}\n\ntextarea::-webkit-resizer {\n  border-width: 100px; /* Make it really large, so we always see the border as a triangle */\n  border-style: solid;\n  border-color: transparent var(--border-color) var(--border-color) transparent;\n  border-bottom-right-radius: calc(var(--dialog-border-radius) - 1px);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
